import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementBinTypeAddComponent } from './case-management-bin-type-add.component';

const routes: Routes = [{ path: '', component: CaseManagementBinTypeAddComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementBinTypeAddRoutingModule { }
